const tutorialReducer = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_TUTORIAL':
      return !state;
    case 'SET_TUTORIAL_EXPANDED':
      return action.payload;
    default:
      return state;
  }
};

export default tutorialReducer;